module.exports = __webpack_public_path__ + "assets_1789978653902/img/pic_9.fc8fc62c.png";